import { ValidatorFn } from "@angular/forms";

export interface TableFiltersField {
  name: string;
  label: string;
  type: TableFiltersFieldType;
  typeSearch: TableFiltersSearchType;
  placeholder?: string;
  validators?: ValidatorFn[];
  options?: any[];
  selectedOption?: any;
  labelOption?: any;
  valueOption?: any;
  range?: boolean;
}

export type TableFiltersFieldType =
  | 'text'
  | 'number'
  | 'select'
  | 'date'
  | 'checkbox';

export enum TableFiltersSearchType {
  ID = 0,
  DATE = 1,
  SUBSTRING = 2,
  KEY = 3,
  BOOL = 4
}

export interface TableFiltersOutput {
  object: any;
  ODataFilters: any;
};

export interface TableFiltersOptions {
  width: number;
  inline: boolean;
}
